
import { Component, Vue } from 'vue-property-decorator';

import mainStore from '@/store/main-store/MainStore';

import { Todo } from '@/webservices/models/Todo';

@Component({
    name: 'AddTodo',
})
export default class AddTodo extends Vue {
    private mainStore = mainStore.context(this.$store);

    private description: string = '';
    private name: string = '';

    private addTodo(): void {
        const todo: Todo = {
            userId: 1,
            title: this.name,
            completed: true,
        };

        this.mainStore.actions.addTodo(todo);

        this.$emit('close');
    }
}
